import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Client } from 'app/types/client.types';
import { TrinityService } from 'app/services/trinity/trinity.service';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private readonly endpoint: string = '/client/v2/me';

  constructor(private trinityService: TrinityService) {}

  getClient(): Observable<Client> {
    return this.trinityService.get<Client>(this.endpoint, { authorized: true });
  }
}
